import { render, staticRenderFns } from "./return_refund_policy.vue?vue&type=template&id=3e44d323&scoped=true"
import script from "./return_refund_policy.vue?vue&type=script&lang=js"
export * from "./return_refund_policy.vue?vue&type=script&lang=js"
import style0 from "./return_refund_policy.vue?vue&type=style&index=0&id=3e44d323&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e44d323",
  null
  
)

export default component.exports